var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 18v.75a3 3 0 1 1-6 0V18m11.048-1.527c-1.204-1.473-2.054-2.223-2.054-6.285 0-3.72-1.9-5.044-3.463-5.688a.835.835 0 0 1-.466-.495C13.791 3.072 13.022 2.25 12 2.25s-1.79.823-2.062 1.756a.827.827 0 0 1-.467.494c-1.565.645-3.462 1.965-3.462 5.688-.003 4.062-.853 4.812-2.056 6.285-.499.61-.062 1.527.81 1.527h14.479c.868 0 1.302-.92.806-1.527z",
    stroke: "#192048",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/BellIcon.070b798eb0f398a5a151e11322c3ce81.svg";
export { ForwardRef as ReactComponent };